import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  headerTextStyle: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "16px",
    color: "#272525",
  },
  notFoundBox: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  main: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "5px",
  },
  mainHeading: {
    fontSize: "24px",
    fontWeight: "bold",
  },
  mainDescription: {
    fontSize: "14px",
  },
  mainPrice: {
    fontSize: "20px",
    fontWeight: "bold",
  },
  currentPlanInfoBox: {
    display: "flex",
    alignItems: "center",
    margin: "7px 0",
    padding: "7px",
    borderRadius: "6px",
    gap: "7px",
    backgroundColor: "#E6F4EA",
    width: "100%",
  },
  currentInfoTextBox: {
    fontSize: "16px",
    fontWeight: "400",
    color: "rgb(39,37,37)",
  },
  currentInfoPriceBox: {
    fontSize: "20px",
    fontWeight: "bold",
  },
  currentInfoPriceText: {
    color: "#999",
    fontSize: "15px",
    fontWeight: "normal",
  },
  infoErrorIcon: {
    color: "#34A853",
    height: "25px",
    width: "25px",
  },
  countFigure: {
    fontWeight: "bold",
  },
  formBox: {
    width: "100%",
    display: "flex",
    gap: "15px",
  },
  footerBox: {
    display: "flex",
    justifyContent: "space-between",
    mt: 2,
    borderTop: "1px solid #bfbcbc",
    paddingTop: "15px",
  },
  footerInfoBox: {
    display: "flex",
    alignItems: "flex-end",
  },
  infoDollar: {
    fontSize: "18px",
    fontWeight: "bold",
    lineHeight: "1",
    alignSelf: "flex-start",
  },
  infoPrice: {
    fontSize: "2.0rem",
    fontWeight: "bold",
    lineHeight: "1",
    marginLeft: "2px",
    marginRight: "4px",
  },
  intervalText: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "text.secondary",
  },
  footerBtn: {
    textTransform: "capitalize",
    bgcolor: "#4d1277",
    color: "white",
    "&:hover": {
      bgcolor: "#4d1277",
      color: "white",
    },
    minWidth: "120px",
  },
  progressIndicator: {
    color: "white",
    marginLeft: "5px",
  },
}));

export default useStyles;
